import React from "react";
import AppRoutes from "./routes/AppRoutes";
import { CssBaseline } from "@mui/material";

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <AppRoutes />
    </>
  );
};

export default App;
